import {useState} from "react";
import {useTranslation} from "react-i18next";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Button from "../../common/button/button";
import {newModalStyle} from "../../reusable/styles";
import ModalCancelTicket from "./modalCancelTicket";

const ModalPlateConflict = ({
  open,
  conflict,
  currentTicket,
  editData,
  editTicket,
  cancelTicket,
  onCancelledCurrent,
  onClose,
}) => {
  const { t } = useTranslation();
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [cancellingOther, setCancellingOther] = useState(true);

  const handleAbort = () => {
    onClose();
  };

  const handleCancelOtherAndProceed = () => {
    setCancellingOther(true);
    setCancelModalOpen(true);
  };

  const handleCancelCurrent = () => {
    setCancellingOther(false);
    setCancelModalOpen(true);
  };

  const handleCancelSuccess = () => {
    onClose();
    if (cancellingOther) {
      editTicket(editData);
    } else {
      onCancelledCurrent();
    }
  };

  const ticketForCancelModal = cancellingOther
    ? { id: conflict?.conflictingTicketId }
    : currentTicket;

  return (
    <>
      <Modal
        open={open}
        closeOnEsc={false}
        onClose={handleAbort}
        center
        styles={newModalStyle({ width: "450px" })}
      >
        <div className="modal__title">{t("ModalPlateConflict.title")}</div>
        <p style={{ marginBottom: "24px" }}>
          {t("ModalPlateConflict.message", {
            ticketNumber: conflict?.conflictingTicketNumber,
            plateNumber: conflict?.conflictingCountryCode !== editData?.countryCode
              ? `${conflict?.conflictingCountryCode} - ${editData?.plateNumber}`
              : editData?.plateNumber,
            date: editData?.date ? new Date(editData.date).toLocaleDateString() : "",
          })}
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Button
              text={t("ModalPlateConflict.cancelThis")}
              buttonStyle={{
                width: "100%",
              }}
              onClick={handleCancelCurrent}
              type="button"
          />
          <Button
            text={t("ModalPlateConflict.cancelOther", {
              ticketNumber: conflict?.conflictingTicketNumber,
            })}
            buttonStyle={{
              width: "100%",
            }}
            onClick={handleCancelOtherAndProceed}
            type="button"
          />
          <Button
            text={t("ModalPlateConflict.abort")}
            buttonStyle={{
              width: "100%",
            }}
            onClick={handleAbort}
            type="button"
          />
        </div>
      </Modal>

      {cancelModalOpen && (
        <ModalCancelTicket
          open={cancelModalOpen}
          close={() => setCancelModalOpen(false)}
          ticketForEdit={ticketForCancelModal}
          cancelTicket={cancelTicket}
          onSuccess={handleCancelSuccess}
        />
      )}
    </>
  );
};

export default ModalPlateConflict;
